module.exports = __webpack_public_path__ + "static/media/metakinisi6.d31d5b06.md";